export const AVATAR_COLORS: string[] = [
  "#BFE7FD",
  "#BFF2EF",
  "#D7D1FC",
  "#BFF2CC",
  "#DFE8EC",
  "#EDCCF7",
  "#F3E3CF",
  "#F8CEED",
  "#FEDDC9",
  "#FDECBF",
];

const generateHash = (input: string): number => {
  return input.split("").reduce(
    (prevHash, currVal) =>
      // tslint:disable-next-line:no-bitwise
      ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
    0,
  );
};

const generateColorIndexByUserName = (userName: string): number => {
  const hashNumber = generateHash(userName + userName.length);
  const colorRange = AVATAR_COLORS.length;
  return ((hashNumber % colorRange) + colorRange) % colorRange;
};

export const getAvatarColorByName = (userName?: string): string | undefined => {
  if (!userName) {
    return;
  }

  const index = generateColorIndexByUserName(userName);
  return AVATAR_COLORS[index];
};
